'use client';

import { useState, useCallback } from 'react';
import Multilingual from '@/src/components/global/Multilingual';
import ProgramItem from '../programs/ProgramItem';
import { cx } from '@/src/styles/stylebook';
import { tileCols2, tileCols4 } from '@/src/utils/utils';
export default function RandomPrograms({
  allPrograms
}) {
  if (!allPrograms || allPrograms.length === 0) return null;
  if (allPrograms.every(program => !program.thumbnail || !program.slug || !program.title_kr || !program.title || !program.director)) {
    return null;
  }
  const [programs, setPrograms] = useState(allPrograms);

  // 랜덤으로 8개 선택하는 함수
  const getRandomPrograms = useCallback(allPrograms_0 => {
    const shuffled = [...allPrograms_0].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, 8);
  }, []);
  const refreshPrograms = useCallback(async () => {
    setPrograms(getRandomPrograms(allPrograms));
  }, [getRandomPrograms]);

  // 초기 데이터에서 랜덤 8개 선택
  const displayPrograms = programs.length > 8 ? getRandomPrograms(programs) : programs;
  return <section className="pt-gutter px-marg -mt-[1px]">
      <div className="mb-0 flex items-center justify-between">
        <h2 className="h2 tracking-tight">
          <Multilingual>Programs</Multilingual>
        </h2>
        <button onClick={refreshPrograms} className={`hover:bg-gray-95 h-12 w-12 rounded-full transition-colors max-md:h-10 max-md:w-10`}>
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" className="h-full w-full">
            <path d="M8.65723 23.1194C10.0245 22.9298 11.2875 23.8849 11.4775 25.2522C11.8811 28.155 13.2272 30.8452 15.3096 32.9075C17.3922 34.9697 20.0962 36.2902 23.0029 36.6653C25.9095 37.0401 28.8589 36.4486 31.3965 34.9827C32.7491 34.2012 33.9431 33.1926 34.9355 32.0129H32.501C31.1204 32.0129 30.0012 30.8935 30.001 29.5129C30.001 28.1322 31.1203 27.0129 32.501 27.0129H40.334C41.7145 27.0132 42.834 28.1324 42.834 29.5129V37.3459C42.8339 38.7265 41.7145 39.8457 40.334 39.8459C38.9535 39.8458 37.8341 38.7265 37.834 37.3459V36.2561C36.6742 37.441 35.3528 38.4725 33.8984 39.3127C30.411 41.3275 26.3568 42.1396 22.3623 41.6243C18.368 41.1088 14.6538 39.294 11.792 36.4602C8.93014 33.6262 7.07885 29.929 6.52441 25.9397C6.33463 24.5723 7.28981 23.3094 8.65723 23.1194ZM15.4375 7.96313C18.925 5.94847 22.9782 5.1362 26.9727 5.65161C30.9671 6.16712 34.6822 7.98169 37.5439 10.8157C40.4055 13.6497 42.2562 17.3461 42.8105 21.3352C43.0005 22.7025 42.0459 23.9652 40.6787 24.1555C39.3113 24.3455 38.0487 23.391 37.8584 22.0237C37.455 19.1208 36.1077 16.4307 34.0254 14.3684C31.9429 12.3062 29.2396 10.9858 26.333 10.6106C23.4262 10.2355 20.4763 10.8262 17.9385 12.2922C16.5855 13.0739 15.3911 14.0828 14.3984 15.2629H16.834C18.2145 15.2632 19.334 16.3824 19.334 17.7629C19.3338 19.1433 18.2144 20.2627 16.834 20.2629H9.00098C7.6204 20.2629 6.5012 19.1435 6.50098 17.7629V9.92896C6.50117 8.54841 7.62038 7.42896 9.00098 7.42896C10.3814 7.42918 11.5008 8.54855 11.501 9.92896V11.0178C12.6607 9.83306 13.9833 8.80327 15.4375 7.96313Z" fill="black" />
          </svg>
        </button>
      </div>

      <div className="-mx-marg relative flex flex-wrap">
        {/* bg only */}
        <div className={cx('-bottom-gutter absolute -top-[calc(var(--spacing-gutter)*2.3+var(--text-size-h2)*1.3)] right-0 left-0 -z-1 flex px-3', 'max-lg:w-full max-lg:p-0')}>
          <div className={cx('bg-system-tilebg -ml-3 w-[calc(100%*(1/4)+var(--spacing)*3)]',
        // 'max-lg:ml-0 max-lg:w-1/3',
        'max-md:ml-0 max-md:w-1/2')}></div>
          <div className={cx('w-1/4', 'max-md:w-1/2'
        // 'max-lg:w-1/3'
        )}></div>
          <div className={cx('bg-system-tilebg w-1/4 max-md:hidden'
        // "max-lg:w-1/3 "
        )}></div>
          <div className="w-1/4 max-md:hidden"></div>
        </div>
        <div className="flex w-full flex-wrap">
          {displayPrograms.map((program_0, i) => <ProgramItem key={program_0._id} program={program_0} className={cx('pt-gutter mb-0! w-[calc(100%*(1/4)-var(--spacing)*1.5)] px-2 pb-20', 'md:nth-[4n-3]:pl-marg md:nth-[4n-3]:w-[calc(100%*(1/4)+var(--spacing)*1.5)]',
        // 'max-lg:nth-[3n-2]:pl-marg max-lg:w-1/3 max-lg:nth-[3n-2]:w-[calc(100%*(1/3)+var(--spacing)*1.5)]',
        'max-md:odd:pl-marg max-md:even:pr-marg max-md:w-1/2',
        // tile 4, 3, 2
        tileCols4(i) ? 'bg-gray-100' : 'bg-system-tilebg',
        // 'max-lg:odd:bg-system-tilebg max-lg:even:bg-gray-100',
        tileCols2(i) ? 'max-md:bg-system-tilebg' : 'max-md:bg-gray-100')} />)}
        </div>
      </div>
    </section>;
}
//
// 'nth-[4n-2]:w-[calc(100%*(1/4)-var(--spacing)*2)]',
// 'nth-[4n-1]:w-[calc(100%*(1/4)+var(--spacing)*1)]',
// 'nth-[4n]:w-[calc(100%*(1/4)+var(--spacing)*1)]'